/*eslint-disable*/
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';

import App from '@/App';

import * as serviceWorker from '@/serviceWorker';
import reportWebVitals from '@/reportWebVitals';

import { I18nextProvider } from 'react-i18next';
import i18n from './i18n/i18n';

import store from '@/redux/store';

// ----------------------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Provider store={store}>
    <I18nextProvider i18n={i18n}>
      <App />
    </I18nextProvider>
  </Provider>
);

// If you want to enable client cache, register instead.
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
